export default function TermsCheckbox({ t, form, set, errors }) {
  const tt = t.booking.terms;
  return (
    <div>
      <label
        className={`flex items-start gap-3 p-4 rounded-xl border-2 cursor-pointer transition-colors ${
          errors.terms_accepted
            ? "border-[var(--accent)] bg-[var(--accent)]/5"
            : "border-[var(--secondary)]/30 bg-[var(--secondary)]/5"
        }`}
      >
        <input
          type="checkbox"
          checked={form.terms_accepted}
          onChange={(e) => set("terms_accepted", e.target.checked)}
          className="mt-0.5 w-5 h-5 shrink-0 accent-[var(--secondary)]"
          data-testid="booking-terms-checkbox"
        />
        <span className="text-sm text-slate-700 leading-relaxed">
          {tt.pre}
          <a href="/aszf" target="_blank" rel="noopener noreferrer" className="font-semibold text-[var(--primary)] underline" data-testid="booking-terms-aszf-link">
            {tt.aszfLink}
          </a>
          {tt.mid}
          <a href="/adatvedelem" target="_blank" rel="noopener noreferrer" className="font-semibold text-[var(--primary)] underline" data-testid="booking-terms-gdpr-link">
            {tt.gdprLink}
          </a>
          {tt.post}
        </span>
      </label>
      {errors.terms_accepted && (
        <p
          className="text-xs font-semibold text-[var(--accent)] mt-1.5"
          data-testid="booking-terms-error"
        >
          {errors.terms_accepted}
        </p>
      )}
    </div>
  );
}
